import { MDM_INTEGRATION_SETTINGS_ID } from '../shared/constants';

/** The only things that differ between the Intune cards; the form itself is shared. */
export interface IntuneTenant {
  /** `mdm_integration.id` used for settings, check-connection and sync. */
  integrationId: number;
  /** Key this card owns in the Integrations `mode` map. */
  modeKey: string;
  /** Card heading. */
  title: string;
  /** Name used in snackbar messages. */
  label: string;
}

export const INTUNE_PRIMARY_TENANT: IntuneTenant = {
  integrationId: MDM_INTEGRATION_SETTINGS_ID.INTUNE,
  modeKey: 'intune',
  title: 'Microsoft Intune',
  label: 'Intune',
};

export const INTUNE_SECONDARY_TENANT: IntuneTenant = {
  integrationId: MDM_INTEGRATION_SETTINGS_ID.INTUNE_SECONDARY,
  modeKey: 'intuneSecondary',
  title: 'Intune - Secondary',
  label: 'Intune - Secondary',
};
